import { ecsClientSettings } from '../initializeAnalytics';
import { AriaDatapoint } from '../datapoints/AriaDatapoint';
import { RequiredProperties } from '../types/EcsTelemetrySettingTypes';

export function checkAllRequiredProperties(
    datapoint: AriaDatapoint,
    properties: RequiredProperties[]
): boolean {
    return (
        properties.length == 0 || properties.every(p => checkRequiredPropertyExists(datapoint, p))
    );
}

export function checkRequiredPropertyExists(
    datapoint: AriaDatapoint,
    requiredProperty: RequiredProperties
): boolean {
    if (
        requiredProperty?.valueType &&
        requiredProperty?.name &&
        datapoint.properties[requiredProperty?.parentJsonField]
    ) {
        const fieldJson = JSON.parse(
            <string>datapoint.properties[requiredProperty.parentJsonField]
        );
        switch (requiredProperty.valueType) {
            case 'enum': {
                if (
                    ecsClientSettings.sharedEnums &&
                    requiredProperty.enumType &&
                    fieldJson[<string>requiredProperty.name] &&
                    ecsClientSettings.sharedEnums[requiredProperty.enumType]
                ) {
                    return (
                        ecsClientSettings.sharedEnums[requiredProperty.enumType].indexOf(
                            fieldJson[<string>requiredProperty.name]
                        ) > -1
                    );
                }
                break;
            }
            case 'string':
            case 'number': {
                return (
                    typeof fieldJson[<string>requiredProperty.name] === requiredProperty.valueType
                );
            }
        }
    }
    return false;
}
